import axios from 'axios'
import { useEffect, useState } from 'react'
import type { CatalogRow } from './CatalogList.types'

export function useCatalogData() {
  const [rows, setRows] = useState<CatalogRow[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const load = async () => {
      setLoading(true)
      setError(null)

      try {
        const { data } = await axios.get<{
          count: number
          list: CatalogRow[]
        }>('/catalog')

        setRows(data.list)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load catalog')
      } finally {
        setLoading(false)
      }
    }

    load()
  }, [])

  return { rows, setRows, loading, error }
}
